export const types = {
    CLOSE_TOKEN_EXPIRED: 'CLOSE_TOKEN_EXPIRED',
    OPEN_TOKEN_EXPIRED: 'OPEN_TOKEN_EXPIRED'
};